module.exports = "/_next/static/images/Hero@2x-ecc1976ec8043945ac0525ac0e35aec9.png";